import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

import { INTEGRATION_ASSET } from './schema';

const MUTATION = gql`
  mutation IntegrationAssetsPerformAction(
    $customerId: ID!
    $workspaceId: ID
    $integrationAssetId: ID
    $accountId: ID
    $dataSource: IntegrationDataSourceEnum!
    $actionsList: [IntegrationActionTypeEnum!]!
    $customModelBrandVoiceId: ID
  ) {
    integrationAssetsPerformAction(
      customerId: $customerId
      workspaceId: $workspaceId
      integrationAssetId: $integrationAssetId
      accountId: $accountId
      dataSource: $dataSource
      actionsList: $actionsList
      customModelBrandVoiceId: $customModelBrandVoiceId
    ) {
      ...IntegrationAsset
    }
  }
  ${INTEGRATION_ASSET}
`;

export const integrationAssetsPerformAction = (
  {
    customerId,
    workspaceId,
    integrationAssetId,
    accountId,
    dataSource,
    actionsList,
    customModelBrandVoiceId,
  },
  options
) => {
  return executeGqlMutation({
    mutation: MUTATION,
    variables: {
      customerId,
      workspaceId,
      integrationAssetId,
      accountId,
      dataSource,
      actionsList,
      customModelBrandVoiceId,
    },
    options: {
      abortSignal: options?.abortSignal,
      traceAcRequests: true,
    },
  }).then(({ data }) => getSingleProp(data));
};
